module.exports = __webpack_public_path__ + "assets/purple_background.5768b2e49cfbea499029e5e3edef1cfbd7cf8c7c355d75c6f0f23a057c5e9a9b.jpg";